'use client';
import { rem } from '@s7/styles';

var getCircularVariantSizes = function(param) {
    var height = param.height;
    return {
        height: height ? rem(height) : "auto",
        width: height ? rem(height) : "100%",
        borderRadius: "50%"
    };
};

export { getCircularVariantSizes };
